export const trackEvent = (payload: any) => {
  if (window.dataLayer) {
    window.dataLayer.push(payload);
  }
};
